import { apiRequest } from "./http";
import type { DashboardSummary } from "./generated/openapi";

export type {
  DashboardPerson,
  DashboardProject,
  DashboardSummary,
} from "./generated/openapi";

export const dashboardApi = {
  get: (signal?: AbortSignal) =>
    apiRequest<DashboardSummary>("/api/dashboard", { signal }),
};
